import React from "react";

const VARIANTS = {
  primary:   { src: "/brand/primary-logo.webp",   alt: "PAID DEWZ Tattoo Studio · Black & Grey Realism · Private Studio · By Appointment Only" },
  monogram:  { src: "/brand/monogram.webp",       alt: "PAID DEWZ" },
  alternate: { src: "/brand/alternate-lockup.png", alt: "PAID DEWZ Tattoo Studio" },
  submark:   { src: "/brand/submark.webp",        alt: "" },
};

/**
 * Brand component — renders the PAID DEWZ logo.
 * Drop replacement files at /app/frontend/public/brand/<filename>.png (or .svg)
 * and update VARIANTS above. No layout changes required.
 */
export default function Brand({ variant = "primary", className = "", style = {}, alt }) {
  const v = VARIANTS[variant] || VARIANTS.primary;
  return (
    <img
      src={v.src}
      alt={alt || v.alt}
      className={className}
      style={style}
      data-testid={`brand-${variant}`}
      draggable={false}
    />
  );
}

/**
 * Horizontal brand lockup — PD monogram + "PAID DEWZ" / "Tattoo Studio" stacked
 * type to its right. Used in TopNav + Footer where vertical real estate is tight.
 *
 * Sizes:
 *   sm — nav bar (default)
 *   md — footer / inline section divider
 *   lg — hero secondary use
 */
export function BrandLockup({ size = "sm", className = "", showStudio = true, dataTestId = "brand-lockup" }) {
  const cfg = {
    sm: { mono: "h-9 w-9",  word: "text-base",  studio: "text-[9px]",  gap: "gap-3" },
    md: { mono: "h-14 w-14", word: "text-2xl",  studio: "text-[10px]", gap: "gap-4" },
    lg: { mono: "h-20 w-20", word: "text-3xl",  studio: "text-xs",     gap: "gap-5" },
  }[size] || { mono: "h-9 w-9", word: "text-base", studio: "text-[9px]", gap: "gap-3" };

  return (
    <div
      className={`inline-flex items-center ${cfg.gap} ${className}`}
      data-testid={dataTestId}
    >
      <img
        src={VARIANTS.monogram.src}
        alt=""
        aria-hidden="true"
        draggable={false}
        className={`${cfg.mono} object-contain shrink-0`}
      />
      <div className="flex flex-col leading-none">
        <span className={`font-display tracking-[0.24em] text-[#E8E9E3] ${cfg.word}`}>
          PAID DEWZ
        </span>
        {showStudio && (
          <span className={`overline mt-1.5 text-[#D2A853] tracking-[0.32em] ${cfg.studio}`}>
            Tattoo Studio
          </span>
        )}
      </div>
    </div>
  );
}
